import React from 'react';
import { useProductToggle } from '../../ToggleProduct/ToggleProductContainer/useProductToggle';
import './toggleProduct.scss'

export const ToggleProduct = () => {
    const { prevPanel, nextPanel, changeActivePart } = useProductToggle();

    return <>
        {prevPanel ? 
            <div className='prev-panel'>
                <button data-value={prevPanel} 
                        className='prev-panel-btn'
                        onClick={changeActivePart} />
            </div> : 
        null}
        {nextPanel ? 
            <div className='next-panel'>
                <button data-value={nextPanel} 
                        className='next-panel-btn'
                        onClick={changeActivePart} />
            </div> : 
        null}
    </>
}